import { mapActions, mapGetters } from "vuex";
import EconomyApi from "@/services/apiPdf/EconomyApi";
import EmailService from "@/services/email/Email";
import EconomyReportService from "@/services/server/EconomyReportService";

import { generateXlsx, generateResumeXlsx } from "./ReportGenerateXLSX";

import FormReport from "@/components/Forms/Report/Report.vue";
import DialogSendEmail from "@/components/DialogSendEmail/DialogSendEmail";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import Utils from '@/scripts/Utils';

export default {
  components: {
    FormReport,
    DialogSendEmail
  },
  data() {
    return {
      show_expand: true,
      main_headers: [
        {
          text: 'Cliente',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Referencia', value: 'reference', align: 'center' },
        { text: 'Conta', value: 'account_value', align: 'center' },
        { text: 'Água (M³)', value: 'water_liters', align: 'center' },
        { text: 'Esgoto (M³)', value: 'sewer_liters', align: 'center' },
        { text: 'Economia (R$)', value: 'economy_monetary', align: 'center' },
        { text: 'Economia (%)', value: 'economy_percentage', align: 'center' },
        { text: 'Meta', value: 'goal', align: 'center' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
        { text: '', value: 'data-table-expand' },
      ],
      secondary_headers: [
        {
          text: 'Unidade',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Referencia', value: 'reference', align: 'center' },
        { text: 'Conta', value: 'account_value', align: 'center' },
        { text: 'Água (M³)', value: 'water_liters', align: 'center' },
        { text: 'Esgoto (M³)', value: 'sewer_liters', align: 'center' },
        { text: 'Economia (R$)', value: 'economy_monetary', align: 'center' },
        { text: 'Economia (%)', value: 'economy_percentage', align: 'center' },
        { text: 'Meta', value: 'goal', align: 'center' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
      ],
      franchisee_id: null,
      client_id: null,
      unit_id: null,
      startDatePicker: [Utils.formatDate(Utils.get_last_months()[0], '<YYYY>-<MM>'), Utils.formatDate(Utils.get_last_months()[5], '<YYYY>-<MM>')],
      titles_button_download: [{ title: "PDF" }, { title: "XLSX" }, { title: "Gráfico" }, { title: "Email" }],
      last_type_selected: null,
      last_serach_alerts: null,
      loading_units: false,
      data_table: [],
      data_table_expand: [],
      report_type: '',
      pdf_include_unit_details: null,
      summary: {
        reference: 0,
        account_value: 0,
        water_liters: 0,
        sewer_liters: 0,
        economy_monetary: 0,
        economy_percentage: 0,
        goal: 0
      },
      dialog_send_email: false,
      data_body_email: false
    }
  },
  methods: {
    parseReportNumber(value) {
      if (typeof value === 'number') return value
      if (!value) return 0

      const valueString = String(value).trim()
      if (/^-?\d+(\.\d+)?$/.test(valueString)) return Number(valueString)

      const cleanValue = valueString
        .replace(/R\$\s?/g, '')
        .replace(/%/g, '')
        .replace(/M.*/g, '')
        .replace(/\s/g, '')
        .replace(/[^\d.,-]/g, '')

      const normalized = cleanValue.includes(',')
        ? cleanValue.replace(/\./g, '').replace(/,/g, '.')
        : /^-?\d{1,3}(\.\d{3})+$/.test(cleanValue)
          ? cleanValue.replace(/\./g, '')
          : cleanValue

      const numericValue = Number(normalized)
      return Number.isFinite(numericValue) ? numericValue : 0
    },
    getRowsSummary(rows = []) {
      return rows.reduce((summary, line) => {
        const economyMonetary = this.parseReportNumber(line.economy_monetary)
        if (economyMonetary > 0) {
          summary.reference += this.parseReportNumber(line.reference)
          summary.account_value += this.parseReportNumber(line.account_value)
          summary.water_liters += this.parseReportNumber(line.water_liters)
          summary.sewer_liters += this.parseReportNumber(line.sewer_liters)
          summary.economy_monetary += economyMonetary
        }
        return summary
      }, {
        reference: 0,
        account_value: 0,
        water_liters: 0,
        sewer_liters: 0,
        economy_monetary: 0
      })
    },
    sumarryFormatedByRows(rows = this.data_table) {
      const summary = this.getRowsSummary(rows)
      const economyPercentage = summary.reference > 0
        ? ((summary.economy_monetary / summary.reference) * 100).toFixed(2)
        : "0.00"

      return {
        reference: Utils.formatCurrency(summary.reference),
        account_value: Utils.formatCurrency(summary.account_value),
        water_liters: summary.water_liters.toFixed(2) + " M\u00B3",
        sewer_liters: summary.sewer_liters.toFixed(2) + " M\u00B3",
        economy_monetary: Utils.formatCurrency(summary.economy_monetary),
        economy_percentage: isNaN(economyPercentage) ? "0 %" : economyPercentage + "%"
      }
    },
    normalizeReportOption(option) {
      return typeof option === "string" ? { title: option } : option
    },
    getReportOptionType(option) {
      const normalizedOption = this.normalizeReportOption(option)
      return normalizedOption.reportType || normalizedOption.title
    },
    getDownloadOptions(prop, status) {
      const defaultOptions = this.titles_button_download
      if (this.getReportDataType(prop, status) !== "client_id") return defaultOptions

      return [
        { title: "PDF simples", reportType: "PDF", includeUnitDetails: false },
        { title: "PDF completo", reportType: "PDF", includeUnitDetails: true },
        ...defaultOptions.filter(({ title }) => title !== "PDF")
      ]
    },
    async catch_report_tipe(option, func, prop, status) {
      if (this.isReportOptionDisabled(option, prop)) return
      const normalizedOption = this.normalizeReportOption(option)
      this.report_type = this.getReportOptionType(normalizedOption)
      this.pdf_include_unit_details = Object.prototype.hasOwnProperty.call(normalizedOption, "includeUnitDetails")
        ? normalizedOption.includeUnitDetails
        : null
      func(prop, status)
    },
    isEmptyReportRow(prop) {
      if (!prop) return false

      return [
        prop.reference,
        prop.account_value,
        prop.water_liters,
        prop.sewer_liters,
        prop.economy_monetary,
      ].every((value) => this.parseReportNumber(value) === 0)
    },
    isReportOptionDisabled(option, prop) {
      const type = this.getReportOptionType(option)
      return type === "Email" || (type === "PDF" && this.isEmptyReportRow(prop))
    },
    getReportOptionTitle(option, prop) {
      const normalizedOption = this.normalizeReportOption(option)
      const type = this.getReportOptionType(normalizedOption)
      const title = normalizedOption.title
      if (type === "Email") return `${type} - indisponível`

      return this.isReportOptionDisabled(type, prop)
        ? `${title} - sem histórico no período`
        : title
    },
    getCentralizedReportType(type) {
      switch (type) {
        case "franchisee":
          return "franchisee_id"
        case "client":
          return "client_id"
        case "unit":
          return "unit_id"
        default:
          return type
      }
    },
    getHeaderType(type) {
      switch (type) {
        case "franchisee":
          return "client"
        case "client":
          return "unit"
        case "unit":
          return "sector"
        default:
          return type
      }
    },
    getCentralizedReportPayload(data_id) {
      return {
        id: data_id.id,
        type: this.getCentralizedReportType(data_id.type),
        currentUser: this.getCurrentUser.uid,
        rank: this.getCurrentUser.data.rank,
        report_type: "TABLE"
      }
    },
    async loadCentralizedEconomyReport(data_id, onExpand = false) {
      const headerType = this.getHeaderType(data_id.type)
      if (!onExpand) this.setHeaders(headerType)
      else this.setHeadersExpand(headerType)

      if (data_id.type === "franchisee") this.franchisee_id = data_id.id
      if (data_id.type === "client") this.client_id = data_id.id
      if (data_id.type === "unit") {
        this.unit_id = data_id.id
        if (this.last_type_selected === "unit") this.show_expand = false
      }

      if (!onExpand && data_id.type === "franchisee") {
        await this.$nextTick()
      }

      if (!onExpand) this.loading_units = true
      let response = null
      try {
        response = await EconomyReportService.data(
          this.getCentralizedReportPayload(data_id),
          this.startDatePicker
        )
      } finally {
        if (!onExpand) this.loading_units = false
      }
      const report = response.data.data || {}
      const rows = report.rows || []

      if (!onExpand) {
        this.summary = report.summary || {
          reference: 0,
          account_value: 0,
          water_liters: 0,
          sewer_liters: 0,
          economy_monetary: 0,
          economy_percentage: 0,
          goal: 0
        }
        this.data_table = rows
        this.formatValueTable(this.data_table)
      } else {
        this.data_table_expand = rows
        this.formatValueTable(this.data_table_expand)
      }
    },
    async catch_id(data_id, onExpand = false) {
      if (!onExpand) this.summary = {
        reference: 0,
        account_value: 0,
        water_liters: 0,
        sewer_liters: 0,
        economy_monetary: 0,
        economy_consumption: 0,
        goal: 0
      }

      if (!onExpand) {
        this.data_table = []
        this.last_serach_alerts = data_id
        this.last_type_selected = data_id.type
      } else {
        this.data_table_expand = []
      }

      this.show_expand = true
      try {
        await this.loadCentralizedEconomyReport(data_id, onExpand)
      } catch (error) {
        console.error("[Report Economy] centralized calculation failed", error)
        showErrorSnackBar("Erro ao calcular relatório de economia!")
      }
    },
    async formatValueTable(data) {
      data.map((line) => {
        line.reference = Utils.formatCurrency(line.reference)
        line.account_value = Utils.formatCurrency(line.account_value)
        line.water_liters = line.water_liters + " M³"
        line.sewer_liters = line.sewer_liters + " M³"
        line.economy_monetary = Utils.formatCurrency(line.economy_monetary)
        line.economy_percentage = line.economy_percentage + "%"
        line.goal = line.goal + "%"
      })
    },
    async getAlertsPerData(selectDate) {
      this.startDatePicker = selectDate

      if (this.last_serach_alerts) {
        this.catch_id(this.last_serach_alerts)
      }
    },
    orderStartDate() {
      if (this.startDatePicker[0] > this.startDatePicker[1]) {
        this.startDatePicker = [
          this.startDatePicker[1],
          this.startDatePicker[0]
        ]
      }
      this.startDatePicker = [
        this.startDatePicker[0],
        this.startDatePicker[1]
      ]
      return this.startDatePicker
    },
    async onExpand({ item, value }) {
      let type = null
      switch (this.last_type_selected) {
        case "franchisee":
          type = "client"
          break;
        case "client":
          type = "unit"
          break;
      }
      await this.catch_id({ id: item.id, type }, true)
    },
    setHeaders(action) {
      switch (action) {

        case 'client':
          if (this.main_headers.length === 8) {

            this.main_headers.push({ text: 'Ações', value: 'actions', sortable: false, align: 'center' })
            this.main_headers.push({ text: '', value: 'data-table-expand' })

          }
          this.main_headers['0'].text = 'Cliente'
          this.main_headers['0'].value = 'name'
          this.secondary_headers['0'].text = 'Unidade'
          this.secondary_headers['0'].value = 'name'
          break;
        case 'unit':
          if (this.main_headers.length === 8) {
            this.main_headers.push({ text: 'Ações', value: 'actions', sortable: false, align: 'center' })
            this.main_headers.push({ text: '', value: 'data-table-expand' },)
          }
          this.main_headers['0'].text = 'Unidade'
          this.main_headers['0'].value = 'name'
          this.secondary_headers['0'].text = 'Data'
          this.secondary_headers['0'].value = 'date'
          break;
        case 'sector':
          this.main_headers['0'].text = 'Data'
          this.main_headers['0'].value = 'date'
          this.main_headers = this.main_headers.filter(({ value }) => value !== "actions" && value !== "data-table-expand")
          break;
      }
    },
    setHeadersExpand(action) {
      switch (action) {
        case 'client':
          this.secondary_headers['0'].value = 'name'
          break;
        case 'unit':
          this.secondary_headers['0'].value = 'name'
          if (this.secondary_headers.length === 8) this.secondary_headers.push({ text: 'Ações', value: 'actions', sortable: false, align: 'center' })
          break;
        case 'sector':
          this.secondary_headers['0'].value = 'date'
          this.secondary_headers = this.secondary_headers.filter(({ value }) => value !== "actions")
          break;
      }
    },
    getReportDataType(item, status = null) {
      switch (this.last_serach_alerts?.type) {
        case "franchisee":
          return status ? "unit_id" : "client_id"
        case "client":
          if (item?.entity === "client") return "client_id"
          if (item?.entity === "unit") return "unit_id"
          return status ? "modem_id" : "unit_id"
        case "unit":
          if (item?.entity === "unit") return "unit_id"
          return "modem_id"
        default:
          return null
      }
    },
    async generatePdf(item, status = null, option = null) {

      let data = {}
      data.id = item.id
      data.currentUser = this.getCurrentUser.uid
      data.rank = this.getCurrentUser.data.rank
      this.report_type === "" ? data.report_type = "PDF" : data.report_type = this.report_type
      data.type = this.getReportDataType(item, status)
      if (!data.type) {
        console.error("type error!")
      }
      const includeUnitDetails = option && Object.prototype.hasOwnProperty.call(option, "includeUnitDetails")
        ? option.includeUnitDetails
        : this.pdf_include_unit_details
      if (data.type === "client_id" && includeUnitDetails !== null) {
        data.include_unit_details = includeUnitDetails
      }
      if (data.type === "client_id" && item.filterText && item.filterText.trim() && Array.isArray(item.filteredItems)) {
        data.unitIds = item.filteredItems
          .map(({ id }) => id)
          .filter(Boolean)
      }
      const entityName = item.name || "Relatório de economia"

      if (this.report_type === "XLSX") {
        if (!["client_id", "unit_id"].includes(data.type)) {
          showErrorSnackBar("Tipo de relatório XLSX não suportado!")
          this.report_type = ""
          return
        }

        const loadedRows = this.getLoadedRowsForXlsx(data.type, item)
        const report = loadedRows
          ? { metadata: item, rows: loadedRows }
          : (await EconomyReportService.data(data, this.startDatePicker)).data.data || {}
        const reportMetadata = report.metadata || report.entity || {}
        const centralizedRows = (report.rows || []).map((row) => ({ ...row }))
        if (!loadedRows) this.formatValueTable(centralizedRows)

        if (data.type === "unit_id") {
          const monthSelect = centralizedRows
          const unit = {
            ...item,
            ...reportMetadata,
            ...(report.summary || {})
          }
          await generateXlsx([{ ...unit, monthSelect }])
        } else {
          const resultSumHistoric = centralizedRows
          const client = {
            ...item,
            ...reportMetadata,
            ...(report.summary || {})
          }
          await generateResumeXlsx([{ ...client, resultSumHistoric }])
        }
      } else if (this.report_type === "Email") {
        this.dialog_send_email = !this.dialog_send_email
        this.data_body_email = { data, startDatePicker: this.startDatePicker, name: entityName }
      } else {
        let response = await EconomyApi.generatePdf(data, this.startDatePicker)
        response.data && response.data.success == true ? await EconomyApi.downloadPdf(this.orderStartDate()[0] + "_" + this.orderStartDate()[1] + " " + entityName) : showErrorSnackBar("Erro ao gerar pdf!")
      }
      this.report_type = ""
      this.pdf_include_unit_details = null
    },
    getLoadedRowsForXlsx(type, item) {
      if (type === "unit_id" && this.last_serach_alerts?.type === "unit" && item.id === this.unit_id) {
        return this.data_table.map((row) => ({ ...row }))
      }

      if (type === "client_id" && this.last_serach_alerts?.type === "client" && item.id === this.client_id) {
        return this.data_table.map((row) => ({ ...row }))
      }

      return null
    },
    async sendEmail(receiver, message) {
      try {
        if (!this.data_body_email) throw "Body não definido!"
        const name = this.data_body_email.name
        const user_email = receiver
        const relatorio = "Financeiro"
        const data = {
          id: this.data_body_email.data.id,
          currentUser: this.data_body_email.data.currentUser,
          rank: this.data_body_email.data.rank,
          report_type: 'PDF',
          type: this.data_body_email.data.type,
          unitIds: this.data_body_email.data.unitIds
        }
        const date_time = this.data_body_email.startDatePicker
        const file_name = this.data_body_email.name.split(" ").join("_")
        const endpoint = "/report/economy"

        await EmailService.sendEmail({
          name,
          user_email,
          relatorio,
          data,
          date_time,
          file_name,
          endpoint
        })

        showSuccessSnackBar("Email enviado!")
      } catch (err) {
        console.error(err)
        showErrorSnackBar("Erro ao enviar email!")
      }
      this.data_body_email = null
    },

  },
  computed: {
    ...mapGetters([
      "getCurrentUser",
    ]),
    sumarryFormated() {
      const everageEconomyPercentage = this.summary.reference > 0
        ? ((this.summary.economy_monetary / this.summary.reference) * 100).toFixed(2)
        : "0.00"
      return {
        reference: Utils.formatCurrency(this.summary.reference),
        account_value: Utils.formatCurrency(this.summary.account_value),
        water_liters: (this.summary.water_liters).toFixed(2) + " M\u00B3",
        sewer_liters: (this.summary.sewer_liters).toFixed(2) + " M\u00B3",
        economy_monetary: Utils.formatCurrency(this.summary.economy_monetary),
        economy_percentage: isNaN(everageEconomyPercentage) ? "0 %" : everageEconomyPercentage + "%"
      }
    }
  }
}
